export default __webpack_public_path__ + "static/media/2930 spice rack D top.f9f0e57e.png";